import React from 'react'
import { useParams } from 'react-router-dom';
import { projects } from '../data/worklog';
import useLink from '../hooks/useLink';
import useComments from '../hooks/modals/useComments';

const ThisProject = ({ children }) => {

  const { projectId } = useParams();
  const prLink = useLink();
  const thisProject = projects.find(project => prLink(project.client) === projectId);
  // const comments = useStore(useComments, state => state.isOpen); // Ensures re-render when `isOpen` changes

  const comments = useComments();

  return (
    <div className="relative flex flex-col items-start justify-start h-full w-full">
      {typeof children === "function"
        ? children({ thisProject, projectId, prLink, comments }) // ✅ Pass comments to function-based children
        : React.Children.map(children, child =>
          child && React.isValidElement(child) // ✅ Ensure child is not null/undefined
            ? React.cloneElement(child, { thisProject, prLink, projectId, comments }) // ✅ Pass props
            : child // ✅ Return unchanged if not a valid React element
        )}
    </div>

  )
}

export default ThisProject